import { AGREEMENTS_TABLE_NAME } from '../../agreements/agreements.constants';
import { AGREEMENT_TABLE_HEADERS } from '../../agreements/models/agreement-sheet.model';
import { agreementDataRowToCellValues } from '../../agreements/utils/agreement-data-row-to-cell-values.util';
import { mapAgreementApiRecordToDataRow } from '../../agreements/utils/map-agreement-api-record-to-data-row.util';
import type { TabularSheetPayload } from '../../shared/tabular-sheet-payload.model';

/** Maps Get-Agreements records into a grid for {@link writeTabularSheetToWorksheet}. */
export function formatAgreementsRecordsToTabularSheet(records: unknown[]): TabularSheetPayload {
    return {
        columnHeaders: AGREEMENT_TABLE_HEADERS,
        rows: records.map((record) => [
            ...agreementDataRowToCellValues(mapAgreementApiRecordToDataRow(record)),
        ]),
        tableName: AGREEMENTS_TABLE_NAME,
    };
}
